// מספר זהות ישראלי - ת.ז., ח.פ., מספר עוסק, ע.ר.: nine digits whose last one is a check digit
// (the Luhn-like rule every Israeli registry uses: the digits are weighted 1,2,1,2,... a product
// above 9 has its digits added, and the sum must divide by 10). The Tax Authority refuses any
// other number for an allocation request (code 432 "Customer vat number is incorrect"), so a
// number that fails here is never worth sending - and a placeholder typed to get past a form
// ("111122223", "123456789") fails it. Shared by the api (apiv2/src/shared symlink) and the
// frontend (../../shared/israeli-id.js).
//
// Digits only, up to nine; shorter numbers are read with leading zeros (the number itself, as the
// Tax Authority gets it, carries none). Spaces and dashes around the digits are ignored.

export function normalizeIsraeliId(value) {
    const digits = String(value == null ? '' : value).replace(/[\s-]/g, '');
    if (!/^\d{1,9}$/.test(digits))
        return null;
    return digits.padStart(9, '0');
}

export function isValidIsraeliId(value) {
    const id = normalizeIsraeliId(value);
    if (!id || +id === 0)
        return false;
    let sum = 0;
    for (let i = 0; i < 9; i++) {
        let product = +id[i] * ((i % 2) + 1);
        if (product > 9)
            product -= 9;
        sum += product;
    }
    return sum % 10 === 0;
}
